import { z } from 'zod'

// Accounts
export const erpAccountSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  Classification: z.string(),
  RemoteData: z.any().nullable(),
  RemoteId: z.string(),
})

export type ErpAccount = z.infer<typeof erpAccountSchema>

// Contacts
export const erpCustomerSchema = z.object({
  Id: z.string(),
  RemoteId: z.string(),
  DisplayName: z.string(),
  IsCustomer: z.literal(true),
  IsVendor: z.boolean().nullable(),
})

export const erpVendorSchema = z.object({
  Id: z.string(),
  RemoteId: z.string(),
  DisplayName: z.string(),
  IsCustomer: z.boolean().nullable(),
  IsVendor: z.literal(true),
})

export const erpContactSchema = z.union([erpCustomerSchema, erpVendorSchema])

export type ErpCustomer = z.infer<typeof erpCustomerSchema>
export type ErpVendor = z.infer<typeof erpVendorSchema>
export type ErpContact = z.infer<typeof erpContactSchema>

// Classes and Locations
export const erpClassSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  IsClass: z.literal(true),
  IsLocation: z.literal(false),
  RemoteId: z.string(),
  Type: z.string(),
})

export const erpLocationSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  IsClass: z.literal(false),
  IsLocation: z.literal(true),
  RemoteId: z.string(),
  Type: z.string(),
})

export const erpClassAndLocationSchema = z.union([erpClassSchema, erpLocationSchema])

export type ErpClass = z.infer<typeof erpClassSchema>
export type ErpLocation = z.infer<typeof erpLocationSchema>
export type ErpClassAndLocation = z.infer<typeof erpClassAndLocationSchema>
